import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { Register } from '@app/utils/type-registry';
import { NavigationListInput, NavigationListOutput } from '@trackback/widgets';
import { BaseWidgetComponent } from '../base-widget.component';
import { ParsePipe } from '../../pipes/parse.pipe';
import { DynamicWidgetDirective } from '../../directives/dynamic-widget.directive';
import { MatLegacyListModule } from '@angular/material/legacy-list';
import { NgFor, NgIf, AsyncPipe } from '@angular/common';

@Register('NavigationList')
@Component({
  selector: 'tb-navigation-list',
  templateUrl: './navigation-list.component.html',
  styleUrls: ['./navigation-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    NgFor,
    NgIf,
    MatLegacyListModule,
    DynamicWidgetDirective,
    AsyncPipe,
    ParsePipe,
  ],
})
export class NavigationListComponent
  extends BaseWidgetComponent<NavigationListInput, NavigationListOutput>
  implements OnInit, OnDestroy
{
  async ngOnInit() {
    // Skip Registration
    this.init();
  }

  ngOnDestroy(): void {
    // Skip De-registration
    this.destroy();
  }
}
